import request from '@teetsh/app/src/utils/request';
import { useState } from 'react';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import getUnixTime from '@teetsh/app/src/utils/time/getUnixTime';
import { useTranslation } from 'react-i18next';

interface Props {
  schoolyearId: string;
  schoolId: string;
  onStart: () => void;
  onFinished: () => void;
  onError: () => void;
  livretEleveIds: string[];
  livretEvalId: string;
}

export async function downloadLSU(props: Props) {
  const {
    schoolyearId,
    schoolId,
    onStart,
    onFinished,
    livretEvalId,
    livretEleveIds,
    onError,
  } = props;

  onStart();

  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets/${livretEvalId}/lsu`;
  try {
    const response = await request(requestURL, {
      method: 'POST',
      body: {
        livretEleveIds,
      },
    });
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `import-lsun-${getUnixTime(new Date())}.xml`);
    document.body.appendChild(link);
    link.click();
    onFinished();
  } catch (err) {
    onError();
    onFinished();
  }
}

export function useDownloadLSU(props: { livretEvalId: string }) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const { t } = useTranslation(['carnet']);
  const { notifyError } = useNotification();
  const download = ({ livretEleveIds }: { livretEleveIds: string[] }) =>
    downloadLSU({
      livretEvalId: props.livretEvalId,
      livretEleveIds,
      schoolyearId: schoolyear.id,
      schoolId: school.id,
      onStart: () => setIsDownloading(true),
      onFinished: () => setIsDownloading(false),
      onError: () =>
        notifyError({
          title: t('carnet:livret.downloadLSUError'),
        }),
    });

  return {
    download,
    isDownloading,
  };
}
